const unregisterServiceWorkers = () => {
  if (!("serviceWorker" in navigator)) return

  window.addEventListener("load", async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(registrations.map((registration) => registration.unregister()))

      if ("caches" in window) {
        const cacheKeys = await caches.keys()
        await Promise.all(
          cacheKeys
            .filter((key) => key.startsWith("taphouse-pwa-"))
            .map((key) => caches.delete(key))
        )
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("Service worker cleanup failed:", error)
    }
  })
}

unregisterServiceWorkers()
